@if (!isHelpPanelVisible && showIcon | async) {
  <button
    (click)="changeHelpPanelVisibility()"
    type="button"
    class="pill-button help-button no-outline"
    [@buttonAnimation]="textState"
    (mouseenter)="toggleTextAnimation(true)"
    (mouseleave)="toggleTextAnimation(false)">
    <fa-icon class="help-icon text-light" [icon]="['fas', 'question']"></fa-icon>
    <span class="text-light"
      [ngClass]="{'text-fade-in': textState === 'visible', 'text-fade-out': textState === 'hidden'}"
      [hidden]="textState === 'hidden'">{{'MENU.PORTAL.HELP.TITLE' | translate}}
    </span>
  </button>
}
@if (isHelpPanelVisible) {
  <div class="card help-panel" (rmaOnClickOutside)="changeHelpPanelVisibility()">
    <form [formGroup]="feedbackForm">
      <div>
        <div class="help-card-header">
          <h6 class="card-title">{{'MENU.PORTAL.HELP.TITLE' | translate}}
            <button type="button" class="close pull-right no-outline" aria-label="Close"
              (click)="changeHelpPanelVisibility()">
              <fa-icon [icon]="['far', 'minus']"></fa-icon>
            </button>
          </h6>
        </div>
        <div class="card-body">
          @if (hasFullviewIoAccess$ | async) {
            <div class="d-flex flex-column justify-content-center">
              <button class="btn btn-primary mb-1" (click)="fullviewRequest()">
                {{'FULLVIEW.REUQEST_CALL' | translate}}
              </button>
              <p class="text-center text-muted">{{'FULLVIEW.OR' | translate}}</p>
            </div>
          }
          <div class="row">
            <div class="col-sm-12">
              <textarea formControlName="text" class="form-control help-text"
              [placeholder]="'MENU.PORTAL.HELP.PLACEHOLDER' | translate"></textarea>
            </div>
          </div>
          @if (files.length < 3) {
            <div class="drag-drop">
              <ngx-file-drop dropZoneLabel="Drop files here"
                dropZoneClassName="help-file-drop-zone"
                contentClassName="help-content-zone"
                (onFileDrop)="onFileSelectOrDrop($event)"
                [disabled]="files.length >= 3">
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                  <button type="button" class="btn btn-green-modal text-black-50" (click)="openFileSelector()"
                    [disabled]="files.length >= 3">
                    {{'MENU.PORTAL.HELP.FILE_DROP_INFO' | translate}}
                    <p translate [translateParams]="{filesLeft: getOutstandingFiles(), files: getFileWord()}">
                      MENU.PORTAL.HELP.FILE_INFO
                    </p>
                  </button>
                </ng-template>
              </ngx-file-drop>
              @if (isErrorMsgVisible) {
                <small class="float-right text-danger">{{'MENU.PORTAL.HELP.SIZE_ERROR' | translate}}
                </small>
              }
            </div>
          }
          <div class="container">
            @for (file of files; track file) {
              <div class="row">
                <div class="col-sm-10">
                  {{file.name}}
                </div>
                <div class="col-sm-2">
                  <button type="button" class="close pull-right" aria-label="Close" (click)="removeFile(file)">
                    <fa-icon [icon]="['far', 'times']"></fa-icon>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
        <div>
          <div class="float-right buttons">
            <button class="btn btn-secondary" (click)="cancelHelp()">{{'BTN.CANCEL' | translate}}</button>
            <button class="btn btn-primary ml-1" (click)="sendHelpRequest()" [disabled]="!feedbackForm.valid">
              {{'BTN.SEND' | translate}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
}
